import { PhosphorIcon } from "~/widgets/icons";
import { useModal } from "~/components/modal";
import { coinIcon } from "~/assets/assets";
import { useDenominationGridContext } from "../context/denomination_grid_context";
import { HubbleRewardsContent } from "~/components/brand_l2/hubble_reward_content";

function CoinEarningInformation() {
  const { internalState } = useDenominationGridContext();
  const { updateModalContentGetter, setIsModalOn } = useModal()!;
  const { hubbleCoinRewards } = internalState;
  return (
    <div class="flex flex-col gap-1">
      <p class="flex items-center gap-1 text-mediumBold text-textDark lg:text-bold">
        Earning {hubbleCoinRewards()?.percentage}% rewards{" "}
        <PhosphorIcon
          name="info"
          fontSize={15}
          class="cursor-pointer text-baseSecondaryLight"
          size="bold"
          onClick={() => {
            updateModalContentGetter(() => {
              return <HubbleRewardsContent />;
            });

            setIsModalOn(true);
          }}
        />
      </p>
      <div class="flex items-center gap-1">
        <img src={coinIcon} class="h-[25px] w-[25px]" />{" "}
        <p class="text-h3 text-rewardsYellow">
          {hubbleCoinRewards()?.amount! % 1 === 0
            ? hubbleCoinRewards()?.amount
            : hubbleCoinRewards()?.amount.toFixed(2)}
        </p>
      </div>
    </div>
  );
}

export default CoinEarningInformation;
